export default "__VITE_ASSET__BrW$0j3x__"